/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError,
} from 'rxjs';
import { DatosMascotaActualizar, Mascota, MascotasPorUsuarioCliente } from './mascota.types';
import { environment } from 'src/environments/environment';
import { User } from '../user/user.types';

@Injectable({
    providedIn: 'root',
})
export class MascotaService {
    private urlApiAuth: string = environment.BASE_URL ;
    private _Mascota: BehaviorSubject<Mascota > = new BehaviorSubject<Mascota>(null);
    private _Mascotas: BehaviorSubject<Mascota[] > = new BehaviorSubject<Mascota[]>(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Getter for Mascota
     */
    get Mascota$(): Observable<Mascota> {
        return this._Mascota.asObservable();
    }

    /**
     * Getter for Mascotas
     */
    get Mascotas$(): Observable<Mascota[]> {
        return this._Mascotas.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Get Mascota by id
     */
 
    getMascotas(): Observable<Mascota[]>
    {
        return this._httpClient.get<Mascota[]>(this.urlApiAuth).pipe(
            switchMap((Mascotas: Mascota[]) =>
            {
                this._Mascotas.next(Mascotas);
                return of(Mascotas);
            }),
            catchError((error: any) => {
              return of([]);
            }));
    }

    getMascotasPorIdUsuairo(idUsuario: number): Observable<MascotasPorUsuarioCliente[]>
    {
        
        return this._httpClient.get<MascotasPorUsuarioCliente[]>(this.urlApiAuth+"/citas/mascotas-por-id-usuario/"+idUsuario).pipe(
                map(mascotas => {
                    console.log(mascotas)
                    return mascotas;
                }),
                catchError((error: HttpErrorResponse ) => {
                  
                  console.error('Error en conseguir datos:', error);
                  const errorMascotas: MascotasPorUsuarioCliente[] = [];
                  errorMascotas.push({ error: error.message });
                  return of(errorMascotas);
                })
              );

    }
    getMascotasByUser(id: number): Observable<Mascota[]>
    {
        return this._httpClient.get<Mascota[]>(this.urlApiAuth + '/citas/mascotas-con-tarjetas-por-cliente/' + id);
    }

    getMascotaById(id: string): Observable<Mascota> {
        return this._httpClient.get<Mascota>(this.urlApiAuth + '/' + id).pipe(
            take(1),
            switchMap((Mascota: Mascota) => {
                if (!Mascota) {
                    return throwError(
                        'Could not found Mascota with id of ' + id + '!'
                    );
                }
                this._Mascota.next(Mascota);
                this.updateMascotaInList(Mascota);
                return of(Mascota);
            })
        );
    }

    agregarListaMascotasNuevas(mascota: DatosMascotaActualizar[]): Observable<DatosMascotaActualizar> {
        const url = `${this.urlApiAuth}/citas/lista-mascotas`; 
        return this._httpClient.post<DatosMascotaActualizar>(url, mascota)
        .pipe(
            map(mascotaActualizada => {            
            return mascotaActualizada;
            }),
            catchError(error => {
            return throwError(() => new Error('Error al actualizar la mascota'+error));
            })
        );
    }

    actualizarMascota(mascota: DatosMascotaActualizar): Observable<DatosMascotaActualizar> {
        const url = `${this.urlApiAuth}/citas/mascotas/${mascota.id}`; 
        return this._httpClient.put<DatosMascotaActualizar>(url, mascota)
        .pipe(
            map(mascotaActualizada => {            
            return mascotaActualizada;
            }),
            catchError(error => {
            return throwError(() => new Error('Error al actualizar la mascota'+error));
            })
        );
    }
    deleteMascota(id: string): Observable<boolean> {
        return this._httpClient.delete<any>(this.urlApiAuth + id).pipe(
            take(1),
            switchMap((data: any) => {
                this.updateMascotaInList(this.getMascotaByIdInList(+id));
                return of(data);
            })
        );
    }
    /**
     * Create Mascota
     */
    createMascota(Mascota: Mascota): Observable<Mascota> {
        return this._httpClient.post<Mascota>(this.urlApiAuth, Mascota).pipe(
            take(1),
            switchMap((Mascota: Mascota) => {
                this._Mascotas.next([Mascota, ...this._Mascotas.value]);
                return of(Mascota);
            })
        );
    }

    /*
     *
     *Funciones auxiliares
     */

    // Función para actualizar un objeto Mascota en la lista
    updateMascotaInList(updatedMascota: Mascota): void {
        const currentMascotas = this._Mascotas.getValue();

        if (currentMascotas) {
          const indice = currentMascotas.findIndex(group => group.id === updatedMascota.id);
          if (indice !== -1) {
            currentMascotas[indice] = updatedMascota;
              this._Mascotas.next([...currentMascotas]); // Emite una nueva lista actualizada
          } else {
              console.log(`No se encontró ningún Mascota con el ID ${updatedMascota.id}.`);
          }
      } else {
          console.log('La lista de grupos está vacía.');
      }
    }

    getMascotaByIdInList(id: number): Mascota | null{
        const currentMascotas = this._Mascotas.value;

        if (currentMascotas) {
            this._Mascotas.value.map((Mascota: Mascota) => {
                if (Mascota.id === id) {
                    return Mascota;
                }
            });

            return null;
        }
    }
}
